import styled from 'styled-components'

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`

export const VideoContainerWrapper = styled.div`
  height: auto;
  width: 100%;
  position: relative;
`

export const VideoContainer = styled.div`
  position: relative;
`

export const Video = styled.video`
  height: auto;
  width: 100%;
`

export const TV = styled.button`
  position: absolute;
  height: 6%;
  width: 4%;
  z-index: 10;
  background-color: transparent;
  border: none;
`
//`${Math.floor(Math.random() * 5)}%`;
//`${Math.floor(Math.random() * 3)}%`;

export const TVClusterAButton = styled(TV)`
  top: 40%;
  left: 44%;
`

export const TVClusterBButton = styled(TV)`
  top: 40%;
  left: 52%;
  cursor: not-allowed;
`
